<app-window-title
  [closable]="true"
  title="Facilities (Hospitals)"
  (closed)="close()"></app-window-title>
<div mat-dialog-content>
  <div
    *ngIf="loading"  class="fx-row fx-jc-center fx-ai-center"style="padding: 20px">
    <mat-progress-spinner diameter="40"></mat-progress-spinner>
  </div>

  <div *ngIf="!loading">
    <div  class="fx-col fx-jc-center fx-ai-center"style="margin-bottom: 20px">
      <mat-form-field
        color="warn"
        appearance="outline"
        [ngStyle]="{ width: '100%' }">
        <mat-label>Search Facilities</mat-label>
        <input
          #searchCriteriaInput
          color="warn"
          aria-label="Search facilities"
          matInput
          [value]="searchCriteria"
          (input)="searchCriteria = searchCriteriaInput.value"
          (keyup)="filterFacilities($event)" />
        <mat-hint>Search by name or address</mat-hint>
      </mat-form-field>
      <div
        class="div-container-2 fx-row fx-jc-center fx-ai-center"  >
        <button
          id="cancelSearch"
          [ngClass]="'mdc-button submission-button'"
          (click)="cancelSearch()">
          <span [ngClass]="'mdc-button__label'">Clear</span>
        </button>
      </div>
    </div>

    <mat-accordion
      *ngIf="filteredFacilities.length > 0; else noFacilities"
      class="facilities-accordion">
      <mat-expansion-panel
        *ngFor="let facility of filteredFacilities"
        (opened)="onFacilityExpanded(facility)"
        class="facility-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div  class="fx-row fx-jc-between fx-ai-center"style="width: 100%">
              <div  class="fx-row fx-jc-start fx-ai-center"style="flex: 1">
                <mat-icon
                  class="facility-icon"
                  aria-hidden="false"
                  aria-label="Facility"
                  >business</mat-icon
                >
                <div style="margin-left: 12px">
                  <div class="facility-name">{{ facility.name }}</div>
                  <div
                    class="facility-address"
                    *ngIf="facility.address">
                    {{ facility.address }}
                  </div>
                </div>
              </div>
              <button
                mat-icon-button
                (click)="onEditClick(facility, $event)"
                [attr.aria-label]="'Edit ' + facility.name"
                matTooltip="Edit facility"
                style="margin-right: 4px; color: #666">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px">edit</mat-icon>
              </button>
              <button
                *ngIf="shouldShowInviteButton(facility)"
                mat-button
                color="primary"
                (click)="onInviteClick(facility, $event)"
                style="margin-right: 8px"
                [attr.aria-label]="'Invite ' + facility.name">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px">email</mat-icon>
                INVITE
              </button>
              <button
                *ngIf="shouldShowSendButton(facility)"
                mat-button
                color="accent"
                (click)="onSendClick(facility, $event)"
                style="margin-right: 8px"
                [attr.aria-label]="'Send invitation to ' + facility.name">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px">send</mat-icon>
                SEND
              </button>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="users-container">
          <div
            *ngIf="facility.loadingUsers"  class="fx-row fx-jc-center fx-ai-center"style="padding: 20px">
            <mat-progress-spinner diameter="30"></mat-progress-spinner>
            <span style="margin-left: 12px">Loading users...</span>
          </div>

          <div *ngIf="!facility.loadingUsers && facility.users && facility.users.length > 0">
            <div *ngIf="hasNoIdentifiedOwner(facility)" class="no-owner-warning">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 6px">warning</mat-icon>
              This facility has no designated owner. Add an owner to enable full facility management.
            </div>
            <div class="users-header">
              <span>Users ({{ facility.users.length }})</span>
              <button *ngIf="hasNoIdentifiedOwner(facility)"
                      mat-button color="primary"
                      (click)="onAddOwnerClick(facility, $event)"
                      matTooltip="Add a new owner to this facility">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">person_add</mat-icon>
                Add owner
              </button>
            </div>
            <ul class="users-list">
              <li
                *ngFor="let user of facility.users"
                class="user-item"
                [class.user-item--invitation]="(user.invitationOnly && user.pendingInvitation) || user.authMissing"
                [class.user-item--invitation-revoked]="user.invitationOnly && user.revokedInvitation">
                <div class="fx-row fx-jc-between fx-ai-center">
                  <div class="fx-row fx-jc-start fx-ai-center" style="flex: 1; min-width: 0">
                    <mat-icon
                      class="user-icon"
                      aria-hidden="false"
                      [attr.aria-label]="user.revokedInvitation ? 'Revoked invitation' : user.invitationOnly ? 'Pending invitation' : user.authMissing ? 'No Auth account' : 'User'"
                      >{{ user.revokedInvitation ? 'mail_outline' : user.invitationOnly ? 'mail_outline' : user.authMissing ? 'no_accounts' : 'person' }}</mat-icon
                    >
                    <div class="user-info">
                      <div class="fx-row fx-ai-center" style="gap: 8px">
                        <div class="user-name">{{ user.name || user.userName || user.email || 'Unknown User' }}</div>
                        <span *ngIf="getCanonicalOwnerLabel(user, facility) as ownerLabel" class="silent-owner-badge">
                          <mat-icon style="font-size: 11px; width: 11px; height: 11px; vertical-align: middle; margin-right: 2px">verified</mat-icon>
                          {{ ownerLabel }}
                        </span>
                      </div>
                      <div class="user-details">
                        <span *ngIf="user.email">{{ user.email }}</span>
                        <span *ngIf="user.role" class="user-role">{{ getDisplayRole(user.role) }}</span>
                        <span *ngIf="user.pendingInvitation" class="invitation-pending-label">
                          <mat-icon style="font-size: 13px; width: 13px; height: 13px; vertical-align: middle; margin-right: 2px">schedule</mat-icon>
                          Invitation sent {{ relativeTime(user.pendingInvitation.createdAt) }}
                        </span>
                        <span *ngIf="user.revokedInvitation" class="invitation-revoked-label">
                          <mat-icon style="font-size: 13px; width: 13px; height: 13px; vertical-align: middle; margin-right: 2px">cancel</mat-icon>
                          Invitation revoked
                        </span>
                        <span *ngIf="user.authMissing" class="invitation-pending-label">
                          <mat-icon style="font-size: 13px; width: 13px; height: 13px; vertical-align: middle; margin-right: 2px">warning</mat-icon>
                          No Firebase Auth account — invited but not applied
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="fx-row fx-ai-center fx-gap-4" style="flex-shrink: 0">
                    <button
                      *ngIf="user.pendingInvitation"
                      mat-button
                      color="warn"
                      (click)="onRevokeInvitation(user, facility, $event)"
                      [attr.aria-label]="'Revoke invitation for ' + (user.name || user.email)"
                      matTooltip="Revoke this invitation">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">cancel</mat-icon>
                      {{ user.invitationOnly ? 'Delete Invitation' : 'Revoke' }}
                    </button>
                    <ng-container *ngIf="user.revokedInvitation">
                      <button
                        mat-button
                        color="primary"
                        (click)="onResendInvitation(user, facility, $event)"
                        [attr.aria-label]="'Send new invitation to ' + user.email"
                        matTooltip="Send a new invitation to this address">
                        <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">send</mat-icon>
                        Send Invite
                      </button>
                      <button
                        mat-button
                        color="warn"
                        (click)="onRemoveFromList(user, facility, $event)"
                        [attr.aria-label]="'Remove ' + user.email + ' from list'"
                        matTooltip="Remove this entry from the list">
                        <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">delete_outline</mat-icon>
                        Remove
                      </button>
                    </ng-container>
                    <button
                      *ngIf="isAuthMissingUser(user)"
                      mat-button
                      color="warn"
                      (click)="onDeleteAuthlessUser(user, facility, $event)"
                      [attr.aria-label]="'Delete authless user ' + (user.name || user.email)"
                      matTooltip="Delete Firestore doc — this user has no Firebase Auth account">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">delete</mat-icon>
                      Delete
                    </button>
                    <button
                      *ngIf="isDuplicateOwner(user, facility)"
                      mat-button
                      color="primary"
                      (click)="onSetAsOwner(user, facility, $event)"
                      [attr.aria-label]="'Set ' + (user.name || user.email) + ' as facility owner'"
                      matTooltip="Set as the canonical owner of this facility">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">how_to_reg</mat-icon>
                      Set as Owner
                    </button>
                    <button
                      *ngIf="isDuplicateOwner(user, facility)"
                      mat-button
                      color="warn"
                      (click)="onRemoveOwner(user, facility, $event)"
                      [attr.aria-label]="'Remove duplicate owner ' + (user.name || user.email)"
                      matTooltip="Remove duplicate owner — this account will be disabled">
                      <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">person_remove</mat-icon>
                      Remove
                    </button>
                    <button
                      *ngIf="isOwnerUser(user) && !user.invitationOnly && !user.authMissing"
                      mat-icon-button
                      (click)="onEditUserClick(user, facility, $event)"
                      [attr.aria-label]="'Edit owner ' + (user.name || user.email)"
                      matTooltip="Edit facility owner"
                      style="color: #666">
                      <mat-icon style="font-size: 18px; width: 18px; height: 18px">edit</mat-icon>
                    </button>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <div
            *ngIf="!facility.loadingUsers && (!facility.users || facility.users.length === 0)"
            class="no-users-cta">
            <mat-icon class="no-users-cta__icon">group_add</mat-icon>
            <p class="no-users-cta__text">No users yet. Add an owner to get this facility started.</p>
            <button mat-raised-button color="primary"
                    (click)="onAddOwnerClick(facility, $event)">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 4px">person_add</mat-icon>
              Add First User
            </button>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <ng-template #noFacilities>
      <div  class="fx-col fx-jc-center fx-ai-center"style="padding: 40px; text-align: center">
        <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #999">business</mat-icon>
        <p style="margin-top: 16px; color: #999">No facilities found</p>
      </div>
    </ng-template>
  </div>
</div>

<div
  mat-dialog-actions
  style="justify-content: space-between; padding: 16px">
  <button
    mat-button
    color="primary"
    (click)="openAddFacility()">
    <mat-icon style="font-size: 18px; width: 18px; height: 18px; margin-right: 4px">add_business</mat-icon>
    Add facility
  </button>
  <button
    mat-button
    (click)="close()">
    Close
  </button>
</div>
